/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 照片选择器 actions
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-24
 */
import {
  setPhotos,
  appendPhotos,
  restorePhotos,
  updateAllPhotosStatus,
  setBackFromPickerPage as setBackFromPickerPageAction
} from '../slices/photoPickerSlice'

export function setPhotoPickerPhotos(data: any[], from: string | null = null) {
  return setPhotos({ photos: data, from })
}

export function clearPhotoPickerPhotos() {
  return setPhotos({ photos: [], from: null })
}

export function appendPhotoPickerPhotos(data, from = null) {
  return appendPhotos({ photos: data, from })
}

export function restorePhotoPickerPhotos(data: any[]) {
  return restorePhotos({ photos: data, from: 'batch-editor' })
}

export function updateAllPhotoPickerPhotosStatus(photos, status) {
  return updateAllPhotosStatus({ photos, status })
}

export function setBackFromPickerPage(data) {
  return setBackFromPickerPageAction(data)
}
